__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "lesson_homework_microfront";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@hookform/resolvers", "3.10.0", () => (Promise.all([__webpack_require__.e(4398), __webpack_require__.e(9463)]).then(() => (() => (__webpack_require__(89463))))));
			register("@it-incubator/mdx-components", "0.0.18", () => (Promise.all([__webpack_require__.e(5545), __webpack_require__.e(7197), __webpack_require__.e(9289), __webpack_require__.e(9325), __webpack_require__.e(6857), __webpack_require__.e(5322)]).then(() => (() => (__webpack_require__(17197))))));
			register("@it-incubator/ui-kit", "1.0.9", () => (Promise.all([__webpack_require__.e(5545), __webpack_require__.e(1953), __webpack_require__.e(9289), __webpack_require__.e(9325), __webpack_require__.e(6058), __webpack_require__.e(6865), __webpack_require__.e(5940), __webpack_require__.e(2941)]).then(() => (() => (__webpack_require__(71953))))));
			register("@tanstack/react-query", "5.8.1", () => (Promise.all([__webpack_require__.e(4984), __webpack_require__.e(6058), __webpack_require__.e(7123)]).then(() => (() => (__webpack_require__(74984))))));
			register("axios", "1.6.1", () => (Promise.all([__webpack_require__.e(2471), __webpack_require__.e(4107)]).then(() => (() => (__webpack_require__(22471))))));
			register("html-react-parser", "5.0.6", () => (Promise.all([__webpack_require__.e(513), __webpack_require__.e(1020)]).then(() => (() => (__webpack_require__(80513))))));
			register("prismjs", "1.29.0", () => (__webpack_require__.e(976).then(() => (() => (__webpack_require__(10976))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(9201), __webpack_require__.e(9376)]).then(() => (() => (__webpack_require__(99201))))));
			register("react-helmet", "6.1.0", () => (Promise.all([__webpack_require__.e(2791), __webpack_require__.e(5133)]).then(() => (() => (__webpack_require__(52791))))));
			register("react-hook-form", "7.66.0", () => (Promise.all([__webpack_require__.e(9047), __webpack_require__.e(1457)]).then(() => (() => (__webpack_require__(79047))))));
			register("react-redux", "8.1.3", () => (Promise.all([__webpack_require__.e(6340), __webpack_require__.e(9289), __webpack_require__.e(6865), __webpack_require__.e(8915)]).then(() => (() => (__webpack_require__(46340))))));
			register("react-router-dom", "6.18.0", () => (Promise.all([__webpack_require__.e(5521), __webpack_require__.e(4253)]).then(() => (() => (__webpack_require__(75521))))));
			register("react-toastify", "9.1.3", () => (Promise.all([__webpack_require__.e(1231), __webpack_require__.e(515), __webpack_require__.e(9504)]).then(() => (() => (__webpack_require__(1231))))));
			register("react", "18.2.0", () => (__webpack_require__.e(5576).then(() => (() => (__webpack_require__(65576))))));
			register("socket.io-client", "4.7.5", () => (__webpack_require__.e(5147).then(() => (() => (__webpack_require__(25147))))));
			register("zod", "3.22.4", () => (Promise.all([__webpack_require__.e(1290), __webpack_require__.e(6488)]).then(() => (() => (__webpack_require__(21290))))));
			initExternal(88524);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};